import { defineStore } from 'pinia'
import type { DepartmentSearchItem } from '~/types/department'

// State
type State = {
  departments: DepartmentSearchItem[]
  isFetched: boolean
}
const state: () => State = () => ({
  departments: [] as DepartmentSearchItem[],
  isFetched: false,
})

// Getters
const getters = {
  getDepartments(state: State): DepartmentSearchItem[] {
    return state.departments
  },
}

// Store
export const useDepartmentStore = defineStore('departments', {
  state,
  getters,
  actions: {
    async fetchDepartments(): Promise<void> {
      if (!this.isFetched) {
        await this.fetchDepartmentsForce()
      }
    },
    async fetchDepartmentsForce() {
      const { $client } = useNuxtApp()
      const response = await $client.v4.common.departments.search.$get()
      this.departments = response.result.departments
      this.isFetched = true
    },
    setDepartments(departments: DepartmentSearchItem[]): void {
      this.departments = departments
      this.isFetched = true
    },
    resetDepartments() {
      this.departments = [] as DepartmentSearchItem[]
      this.isFetched = false
    },
  },
})
